export default {
  DETACHED_GLOBAL: 'detached',
  DETACHED_CHILDREN_GLOBAL: 'detached-children',
};
